export default __webpack_public_path__ + "static/media/multi-asset-weather-desbanner.ae28474a.jpg";